function initCarousel(carousel) {
  if (carousel.dataset.carouselInitialized) return;
  carousel.dataset.carouselInitialized = 'true';

  const images = carousel.querySelectorAll('.product-card__image');
  const imageWrapper = carousel.querySelector('.product-card__image-wrapper');
  const prevButton = carousel.querySelector('[data-direction="prev"]');
  const nextButton = carousel.querySelector('[data-direction="next"]');

  let currentIndex = 0;

  const updateButtons = () => {
    if (images.length <= 1) {
      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
      return;
    }
    if (prevButton){
      prevButton.disabled = (currentIndex === 0);
      prevButton.classList.toggle('is-disabled', currentIndex === 0);
    }
    if (nextButton){
      nextButton.disabled = (currentIndex === images.length - 1);
      nextButton.classList.toggle('is-disabled', currentIndex === images.length - 1);
    }
  };

  const showImage = (newIndex) => {
    currentIndex = newIndex;
    const offset = -currentIndex * 100;
    imageWrapper.style.transform = `translateX(${offset}%)`;
    carousel.dataset.currentIndex = currentIndex; 
    updateButtons(); 
  };

  const goToNext = () => {
    if (currentIndex < images.length - 1) {
      showImage(currentIndex + 1);
    }
  };

  const goToPrev = () => {
    if (currentIndex > 0) {
      showImage(currentIndex - 1);
    }
  };

  nextButton?.addEventListener('click', goToNext);
  prevButton?.addEventListener('click', goToPrev);

  let touchStartX = 0;
  const swipeThreshold = 50;

  carousel.addEventListener('touchstart', (e) => {
    const productList = carousel.closest('.product-list');
    const isScrollable = productList && productList.classList.contains('is-scrollable');
    if (isScrollable) {
      touchStartX = null;
      return;
    }
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  carousel.addEventListener('touchend', (e) => {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].screenX;
    const swipeDistance = touchEndX - touchStartX;
    if (swipeDistance < -swipeThreshold) goToNext();
    else if (swipeDistance > swipeThreshold) goToPrev();
  });
  
  updateButtons();
}

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[data-card-carousel]');
  carousels.forEach(initCarousel);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          node.querySelectorAll('[data-card-carousel]').forEach(initCarousel);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});